const { env } = require('../../config')
import defaultLayerSettings from '@/store/objects/defaultLayerSettings'
import defaultLayerStyles from '@/store/objects/defaultLayerStyles'
const defaultSettings = {
  centroid: [
    {
      center: [37.0915562, 55.603246],
      zoom: 4
    }
  ],
  defaultAdmLevel: 3,
  bbox_min_zoom: 7,
  osm_tiles_themes: {
    default:
      'https://api.mapbox.com/styles/v1/anjelikaptrv/ck4cuz8z903v41dmwc1nfcz37/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYW5qZWxpa2FwdHJ2IiwiYSI6ImNrNGN1eWk4ajByYTczcnA4eG0xMWVjaW0ifQ.JjJlYg3uS4ifA6B0h1lsaA',
    dark:
      'https://api.mapbox.com/styles/v1/anjelikaptrv/ckjx3ccow0r7n17o1yjtfwpbr/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYW5qZWxpa2FwdHJ2IiwiYSI6ImNrNGN1eWk4ajByYTczcnA4eG0xMWVjaW0ifQ.JjJlYg3uS4ifA6B0h1lsaA'
  },

  /**Настройки списка слоев (левой панели) */
  front_layer_layout: {
    layerSettings: JSON.parse(JSON.stringify(defaultLayerSettings)),
    layerStyles: JSON.parse(JSON.stringify(defaultLayerStyles))
  }
}

export default {
  backendHostname: env.VUE_APP_DEV_BACKEND_HOST
    ? env.VUE_APP_DEV_BACKEND_HOST.endsWith('/')
      ? env.VUE_APP_DEV_BACKEND_HOST
      : `${env.VUE_APP_DEV_BACKEND_HOST}/`
    : '/',
  yandexApiKey: '9ade0b81-a6b5-40c4-8cfa-af573476a4da',
  // TODO: подгрузка эндпоинтов с бэка
  endpoint: {
    yandexGeo: 'https://geocode-maps.yandex.ru/1.x',
    encodeCoordinates: 'api/coordinate/encode/',
    decodeCoordinates: 'api/coordinate/decode/',
    allLayers: 'api/data/layerload/',
    containerplatform: 'api/data/containerplatform/',
    containerplatformById: (id) => 'api/data/containerplatform/' + id + '/',
    containerById: (id) => 'api/data/container/' + id + '/',
    icon: 'api/data/icon/',
    container: 'api/data/container/',
    containertype: 'api/data/containertype/',
    source: 'api/data/source/',
    building: 'api/data/building/',
    transportBase: 'api/data/transportbase/',
    buildingById: (id) => 'api/data/building/' + id + '/',
    emitter: 'api/data/emitter/',
    emitterById: (id) => 'api/data/emitter/' + id + '/',
    sourceMap: 'api/data/source',
    categoryList: 'api/data/category/',
    categorytypeList: 'api/data/categorytype/',
    search: (type) => 'api/search/' + type + '/',
    settings: 'api/data/setting/',
    setting: (id) => 'api/data/setting/' + id + '/',
    admterritory: 'api/data/admterritory/',
    additionallayers: 'api/data/infolayer/',
    streaminfo: 'api/data/streaminfo/',
    simplified_admterritory: 'api/data/admterritory/simplified/',
    separateterritory: 'api/data/dedicatedterritory/',
    simplified_separateterritory: 'api/data/dedicatedterritory/simplified/',
    analytics: 'api/analytics/',
    tokenAuth: 'api/token-auth/',

    /**Эндпоин для авторизации по токену АСУ */
    tokenAsuAuth: 'api/auth-jwt/',

    /**
     * Получение информации о пользователе
     * username
     * id
     * token
     * groups
     * permissions
     */
    me: 'api/me/',

    period: 'api/data/period/',
    zones: 'api/data/zone/',
    copyZone: (id) => 'api/data/zone/' + id + '/copy/',
    zone: (id) => 'api/data/zone/' + id + '/',
    layers: 'api/layers/',
    transfer: 'api/data/cruise/',
    trip: 'api/data/trip/',
    round: 'api/data/round/',
    loopProperties: 'api/data/round_properties/',
    tripProperties: 'api/data/trip_properties/',
    transferProperties: 'api/data/cruise_properties/',
    flow: 'api/data/flow/',
    simplified_transfer: 'api/data/cruise/',
    simplified_trip: 'api/data/trip/',
    simplified_round: 'api/data/round/',
    zoneStat: 'api/data/stats/zone/',
    infrastructure: 'api/data/infrastructure/',
    infrastructureById: (id) => 'api/data/infrastructure/' + id + '/',
    workspaces: 'api/data/workspace/',
    workspaceVersion: 'api/data/dataversion/',
    versionHistory: 'api/data/history/',
    activeWorkspaces: 'api/data/workspace/get_active/',
    workspace: (id) => 'api/data/workspace/' + id + '/',
    activateVersion: (id, workspaceId) => 'api/data/dataversion/' + id + '/activate/',
    versionRequest: 'api/data_version/',
    zonegroups: 'api/data/zonegroup/',
    zonegroup: (id) => 'api/data/zonegroup/' + id + '/',
    analyticSlices: 'api/slices/',
    admLevels: 'api/adm_levels/',
    seasons: 'api/data/season/',
    year: 'api/data/year/',
    entities: {
      transportbase: 'api/data/transportbase/',
      flow: 'api/data/flow/',
      infrastructure: 'api/data/infrastructure/',
      transfer: 'api/data/cruise/',
      removaltrip: 'api/data/trip/',
      collectingloop: 'api/data/round/',
      emitter: 'api/data/emitter/',
      building: 'api/data/building/',
      source: 'api/data/source/',
      containerplatform: 'api/data/containerplatform/',
      zone: 'api/data/zone/',
      zonegroup: 'api/data/zonegroup/',
      admterritory: 'api/data/admterritory/'
    },
    objectDetails: {
      infrastructure: 'api/parameters/infrastructure/',
      zone: 'api/parameters/zone/',
      dedicatedterritory: 'api/parameters/dedicatedterritory/',
      admterritory: 'api/parameters/admterritory/'
    },
    excelLayers: {
      layersList: 'api/aggregate-info-layer/list/',
      layerObjectList: 'api/aggregate-info-layer/get_data/',
      layerObject: 'api/aggregate-info-layer/get_data/',
      addLayer: 'api/aggregate-info-layer/upload/',
      updateLayerObject: 'api/aggregate-info-layer/create_update/',
      updateLayerSettings: 'api/aggregate-info-layer/settings/change/',
      deleteLayer: 'api/aggregate-info-layer/delete/',
      layerSettings: 'api/aggregate-info-layer/settings/',
      layerFile: 'api/aggregate-info-layer/download/',
      colors: 'api/color_parameters/',

      /**История изменений инфослоя (лог) */
      history: 'api/aggregate-info-layer/history/'
    },
    map: {
      admterritory: 'api/map/admterritory/',
      zones: 'api/map/admterritory/',
      borders: 'api/map/admterritory/',
      zonegroup: 'api/map/admterritory/',
      zoneGroupColors: 'api/map/zonegroup_colors/',
      transportbase: 'api/map/transportbase/',
      flow: 'api/map/flow/',
      infrastructure: 'api/map/infrastructure/',
      infrastructureColors: 'api/map/infrastructure_colors/',
      route: 'api/map/route/',
      emitter: 'api/map/emitter/',
      building: 'api/map/building/',
      streaminfoRoute: 'api/aggregate-info-layer/route/',
      source: 'api/map/source/',
      info: 'api/map/aggregate-info-layer/',
      streaminfo: 'api/map/aggregate-info-layer/',
      additionallayer: (id) => 'api/map/infolayer/' + id + '/',
      containerplatform: 'api/map/container_platform/',
      heatmap: 'api/heatmap/'
    },
    color: 'api/data/color/',

    /**Список сохраненных фильтров ws */
    filters: 'api/data/filter/',

    /**Отдельный фильтр по идентификатору */
    filterById: (id) => 'api/data/filter/' + id + '/',

    /**Справочник полей по которым можно фильтровать */
    filterDict: 'api/filter_parameters/',

    /**Отключение всех фильтров */
    filtersSwitchOff: 'api/data/filter/disable_all/',

    mapCache: 'api/map_cache/',
    serviceTree: 'api/service_tree/',
    userLayers: 'api/map/userlayer/',
    userLayerGroups: 'api/map/userlayer_group/',
    userLayerGroup: (id) => 'api/map/userlayer_group/' + id + '/',
    userLayer: (id) => 'api/map/userlayer/' + id + '/',
    excelFiles: 'api/excel/files/',
    excelFile: (type, id) => 'api/excel/files/' + id + '/' + type + '/',
    serviceButtonParameters: 'api/button_parameters/',
    initWorkspaceParameters: 'api/init_button_parameters/',
    createWorkspace: 'service/calc_create_workspace/',
    createWorkspaceById: (id) => 'service/calc_create_workspace/' + id + '/',
    uploadFile: 'api/file_upload/',
    updateButtonParameters: 'api/button_parameter_set/',
    calcButton: 'service/calc_button/',
    calcButtonArray: 'service/calc_buttons/',
    copyVersion: 'service/calc_create_version/',
    copyWorkspace: 'service/calc_copy_workspace/',
    copyWorkspaceById: (id) => 'service/calc_copy_workspace/' + id + '/',
    priorityRules: 'api/data/edge_priority/rules/',
    priorityFlows: 'api/data/edge_link/',
    priorityFlow: (id) => 'api/data/edge_link/' + id + '/',
    downloadPriorityFlows: 'service/export_edge_links/',
    updatePriorityFlows: 'api/data/edge_link/set_range/',
    convertfunctions: 'api/data/convertfunction/',
    economicModels: 'api/data/economics/',
    technologies: 'api/data/technology/',
    technology: (id) => 'api/data/technology/' + id + '/',
    technologyTree: (id) => 'api/data/infrastructure/' + id + '/tree/',
    apiVersion: 'api/code_version_info/',
    reportsList: 'api/export/summary/',
    generateReport: 'api/export/summary/generate/',
    report: 'api/export/summary/download/',
    wastes: 'api/data/wastetype/',
    wasteRuleById: (id) => 'api/data/wastetype/' + id + '/',
    terschema: 'api/data/terschema/',
    terschemaById: (id) => 'api/data/terschema/' + id + '/',
    control: 'api/data/control/',
    controlById: (id) => 'api/data/control/' + id + '/',
    treatments: 'api/data/treatmenttype/',

    /**Предметы на потоках (например: Смешанные отходы, ВРМ, КГО) */
    item: 'api/data/item/',

    limitMemory: 'api/memory_usage/',
    limitDisk: 'api/disk_usage/',
    limitCpu: 'api/process_usage/',

    /**
     * Сброс значений поля
     * entity - название сущности
     * field - название поля
     */
    resetField: 'api/reset_field/',

    /**
     * Типы автомобилей
     */
    cartype: 'api/data/cartype/',

    /**
     * Эндпоинт упраления полями сущностей из задачи https://app.clickup.com/t/2n9yz52
     * GET возращает текущий словарь настроек
     * POST полностью перезаписывает словарь с настройками содержимым из тела запроса
     * (можно использовать для сброса к состоянию с нуля)
     * PUT добавляет новые настройки
     * DELETE удаляет настройки
     * "name": "containerplatform",   - Название сущности (обязательно)
     * "field": "route",   - Название поля (обязательно)
     * "object_id": 5755 - ID объекта (если нужно убрать поле на определенном объекте)
     */
    fieldsControl: 'api/fields_control/'
  },
  apiError: null,
  zones: null,
  zoneGroups: null,
  emitterCategorytypes: null,
  admTerritories: null,
  separatedTerritories: null,
  admLevels: null,
  settings: {
    ...defaultSettings,
    osm_tiles_themes: null
  },
  defaultSettings: JSON.parse(JSON.stringify(defaultSettings)),
  logo: '',
  periods: null,
  years: null,
  seasons: null,
  colors: {},
  helperType: null,
  theme: localStorage.getItem('theme') || 'default',
  convertfunctions: [],
  economicModels: [],
  isInitLoading: false,
  treatments: [],
  apiVersion: null,

  /**Справочник предметов на потоках (например: Смешанные отходы, ВРМ, КГО) */
  items: [],

  dropRuleTypes: [
    {
      id: 'drop_all',
      name: 'Удалять все ребра'
    },
    {
      id: 'drop_input',
      name: 'Удалять входящие ребра'
    },
    {
      id: 'drop_output',
      name: 'Удалять исходящие ребра'
    }
  ],

  /**Кол-во записей в разделе "Терсхема" */
  terschemaListCount: 0,

  /**Кол-во записей в разделе "Контроль" */
  controlListCount: 0
}



// WEBPACK FOOTER //
// ./src/store/defaults.js